import axios from 'axios';
import { Toast } from 'vant';
import {
	getHardWare,
	getSoftWare,
	getDeployNew,
	storageEventEmit,
} from '@/lib/util';
import Store from '../store/index';

const $store = Store;
const $toast = Toast;

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers.Authorization = localStorage.getItem('Authorization') || '';
axios.defaults.headers['hardware-platform'] = getHardWare();
axios.defaults.headers['software-platform'] = getSoftWare();
axios.defaults.headers['deploy-platform'] = getDeployNew();
axios.defaults.timeout = 10000;

// 请求数据拦截器
axios.interceptors.request.use(request => request, err => Promise.reject(err));

// 不走统一报错与数据处理的接口配置
const exceptionAPI = [
	'/api/registration',
];

// token失效错误码捕获
const tokenErrCode = [-102003];
// 接收响应拦截器
axios.interceptors.response.use(
	// eslint-disable-next-line consistent-return
	(response) => {
		// loading close
		$store.commit('setLoading', false);
		if (tokenErrCode.includes(response.data.resultCode)) { // token失效
			storageEventEmit('show-toast', response.data.resultMessage);
			// $toast(response.data.resultMessage);
			localStorage.clear();
			return Promise.reject(response.data);
		}
		if (response.data.resultCode === 0 || exceptionAPI.includes(response.config.url)) {
			return response.data;
		}
		// $toast(response.data.resultMessage);
		storageEventEmit('show-toast', response.data.resultMessage || `服务异常（${response.data.resultCode}）`);
		return Promise.reject(response.data);
	},
	(error) => {
		$store.commit('setLoading', false);
		if (error.response) {
			const { status } = error.response;
			switch (status) {
				case 404:
					// $toast('请求地址不存在！');
					storageEventEmit('show-toast', '请求地址不存在！');
					break;
				case 421:
					$toast('前方拥挤，还请冒险者耐心排队等待');
					break;
				case 567:
					$toast('前方拥挤，还请冒险者耐心排队等待');
					break;
				default:
					// $toast('服务异常！');
					storageEventEmit('show-toast', '服务异常！');
					break;
			}
		}
		return Promise.reject(error);
	},
);

const http = {
	get: (url, data, apiConfig) => {
		if (!apiConfig?.disableLoading) {
			$store.commit('setLoading', true);
		}
		return new Promise((resolve, reject) => {
			if (typeof data === 'object') {
				/* it goes in here when the user has added a data param when calling the get method */
				axios({
					method: 'GET',
					url,
					params: {
						...data,
					},
				}).then((res) => {
					const resultData = exceptionAPI.includes(url) ? res : res?.data;
					resolve(resultData);
				}).catch((err) => {
					reject(err);
				});
			} else {
				axios({
					method: 'GET',
					url,
				}).then((res) => {
					const resultData = exceptionAPI.includes(url) ? res : res?.data;
					resolve(resultData);
				}).catch((err) => {
					reject(err);
				});
			}
		});
	},
	post: (url, data, apiConfig) => {
		if (!apiConfig?.disableLoading) {
			$store.commit('setLoading', true);
		}
		return new Promise((resolve, reject) => {
			if (typeof data === 'object') {
				/* it goes in here when the user has added a data param when calling the get method */
				axios({
					method: 'POST',
					url,
					data,
				}).then((res) => {
					const resultData = exceptionAPI.includes(url) ? res : res?.data;
					resolve(resultData);
				}).catch((err) => {
					reject(err);
				});
			} else {
				axios({
					method: 'POST',
					url,
				}).then((res) => {
					const resultData = exceptionAPI.includes(url) ? res : res?.data;
					resolve(resultData);
				}).catch((err) => {
					reject(err);
				});
			}
		});
	},
	formPost: (url, data, apiConfig) => {
		if (!apiConfig?.disableLoading) {
			$store.commit('setLoading', true);
		}
		return new Promise((resolve, reject) => {
			if (typeof data === 'object') {
				/* it goes in here when the user has added a data param when calling the get method */
				const formData = new FormData();

				Object.keys(data).forEach(key => {
					formData.append(key, data[key]);
				});

				axios({
					method: 'POST',
					url,
					data: formData,
					// transformRequest: [(transformData) => {
					// 	let ret = '';
					// 	Object.keys(transformData).forEach(it => {
					// 		ret += `${encodeURIComponent(it)}=${encodeURIComponent(transformData[it])}&`;
					// 	});
					// 	return ret;
					// }],
				}).then((res) => {
					const resultData = exceptionAPI.includes(url) ? res : res?.data;
					resolve(resultData);
				}).catch((err) => {
					reject(err);
				});
			} else {
				axios({
					method: 'POST',
					url,
				}).then((res) => {
					const resultData = exceptionAPI.includes(url) ? res : res?.data;
					resolve(resultData);
				}).catch((err) => {
					reject(err);
				});
			}
		});
	},
	upload: (url, data, apiConfig) => {
		if (!apiConfig?.disableLoading) {
			$store.commit('setLoading', true);
		}
		return new Promise((resolve, reject) => {
			const file = new FormData();
			file.append('file', data);
			axios.post(url, file, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			}).then((res) => {
				resolve(res?.data);
			}).catch((err) => {
				reject(err);
			});
		});
	},
	setHead: (data) => {
		// 此处可以动态设置统一header
		const { key, value } = data;
		axios.defaults.headers[key] = value;
	},
};

export default http;
